import React, { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { KeyRound } from "lucide-react";
import { toast } from "sonner";
import { useLang } from "@/context/LanguageContext";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { customerApi, formatApiError } from "@/context/CustomerContext";

export default function ResetPasswordPage() {
  const { t } = useLang();
  const a = t.account;
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [pw, setPw] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);
  const navigate = useNavigate();

  const submit = async () => {
    setBusy(true);
    try {
      await customerApi.post("/account/reset-password", { token, new_password: pw });
      setDone(true);
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail, a.reset_invalid));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-brand-soft/30">
      <Navbar />
      <main className="pt-32 pb-24 px-5">
        <div className="max-w-md mx-auto bg-white rounded-[2rem] border border-brand/10 shadow-[0_20px_60px_rgba(134,77,99,0.10)] p-8" data-testid="reset-password-page">
          <span className="mx-auto grid place-items-center h-16 w-16 rounded-full bg-brand-soft text-brand mb-5">
            <KeyRound className="h-7 w-7" />
          </span>
          <h1 className="font-heading text-3xl font-bold text-brand-ink text-center">{a.reset_title}</h1>
          {done ? (
            <div className="text-center mt-6" data-testid="reset-done">
              <p className="text-brand-muted">{a.reset_done}</p>
              <Button onClick={() => navigate("/account")} className="mt-5 rounded-full bg-brand hover:bg-brand-hover text-brand-cream font-bold" data-testid="reset-go-login">
                {a.login}
              </Button>
            </div>
          ) : (
            <div className="mt-6 space-y-4">
              <div>
                <Label className="text-brand-ink font-semibold">{a.new_password}</Label>
                <Input type="password" value={pw} onChange={(e) => setPw(e.target.value)} onKeyDown={(e) => e.key === "Enter" && submit()} className="rounded-xl border-brand/20 bg-white h-11 mt-1 focus-visible:ring-brand" data-testid="reset-new-password" />
              </div>
              <Button onClick={submit} disabled={busy || pw.length < 6 || !token} className="w-full rounded-full bg-brand hover:bg-brand-hover text-brand-cream font-bold h-12" data-testid="reset-submit">
                {a.reset_btn}
              </Button>
            </div>
          )}
        </div>
      </main>
      <Footer />
    </div>
  );
}
